import React, {useState, useEffect} from 'react'
import FieldDropdown from '../components/FieldDropdown';
import BlueButton from '../components/BlueButton';
import { useStateContext } from '../context/StateContext';
import { useAuthContext } from '../whitaijiFrontendLibrary/auth/hooks/useAuthContext';
import { AuthContext } from '../context/AuthContext';
import { isGodMode, NoAccess, isMindPro } from '../utils/permissions';
import T from '../components/Translation';
import { dT } from '../components/Translation';
import { useSignup } from '../whitaijiFrontendLibrary/auth/hooks/useSignup';
import { successAlert } from '../utils/utils';
import { generateMongoDBId } from '../whitaijiFrontendLibrary/lib/utils';
import { useQuery } from '@tanstack/react-query';
import { _FETCH } from '../utils/patches';
import Loading from '../whitaijiFrontendLibrary/components/Loading';


const InviteClient = () => {

      const {user} = useAuthContext(AuthContext)
      const {hideTestButtons, apiUrl, language} = useStateContext()
      const {signup, error, isLoading, result} = useSignup(AuthContext)
      const [email, setEmail] = useState("")
      const [firstName, setFirstName] = useState()
      const [emailError, setEmailError] = useState(null)
      
      const { data: userProfileData, error: userDataError, isLoading: userProfileDataLoading } = useQuery({
        queryKey: ['userProfileData'],
        enabled: !!user, // Only fetch if user is logged in
        queryFn: async () => {
            const userData = await _FETCH({
              route: `${apiUrl}/user/get-user-profile/${user._id}`,
              user,
            });

            return userData;
          }
    });
/*       useEffect(() => {
        if (result?.success) {
          process.env.NODE_ENV === "development" && console.log("result", result)
          successAlert(dT({en: 'Invite sent successfully!', it: 'Invito inviato con successo!'}, language),)
          setEmail("")
        }
      }, [result]) */

      const htmlVersion = (htmlDraft, _id) => {
        return `<html><body style="margin: 0; padding: 0; background-color: #fcba03;">${htmlDraft}<img src='${apiUrl}/email/email-assets/notification-status/${_id}' width='1' height='1' style='display:none' alt='Email notification status' /></body></html>`
    }
    const profilePictureLine = userProfileData?.profilePictureUrl ? `
        <div style="display: flex; align-items: center; justify-content: center; margin-bottom: 30px;">
          <div style="flex: 1; height: 1px; background-color: #ccc;"></div>
            <img src="${userProfileData?.profilePictureUrl}" alt="Logo" style="width: 80px; border-radius: 50%; height: 80px; margin: 0 20px;">
          <div style="flex: 1; height: 1px; background-color: #ccc;"></div>
        </div> 
    `:""
    const userFirstName = userProfileData?.firstName ? userProfileData?.firstName : ""
    const userLastName = userProfileData?.lastName ? userProfileData?.lastName : ""
    const userProfessionalTitle = userProfileData?.professionalTitle ? userProfileData?.professionalTitle : ""
    const userFullName = `${userFirstName} ${userLastName} `
    const firstLine = firstName ? `${dT({en:'Dear', it:'Gentile'}, language)} ${firstName},` : `${dT({en:'Greetings, ', it:'Ciao,'}, language)}`
    const reMind = `<span style="color: #fcba03;"><b>reMind</b></span>`
    const footer = `
          <div  
            text-align: center; 
            padding: 30px; 
            width: 100%; 
            box-sizing: border-box; 
            display: flex; 
            justify-content: center; 
            align-items: center; 
            flex-direction: column;"
          >
            <img src="https://www.remind.is/reMindLogo.png" alt="reMind Logo" style="height:80px"} />
            <p style="width:600px; overflow: hidden; color: #343C5F; font-family: Arial, sans-serif;">
              ${ dT({
                  en: ` 
                    reMind is intended to be used as a complementary tool, under the supervision of qualified professionals. 
                    It is not a medical device, and it does not offer healing, treatment, or cures for any health condition.  
                    Always consult with a healthcare professional for medical advice.
                    `,
                  it: 
                    `reMind è stato realizzato come strumento complementare, sotto la supervisione di professionisti qualificati.  
                    Non è un dispositivo medico e non offre guarigione, trattamento o cure per alcuna condizione di salute.
                    Consultare sempre un professionista sanitario per consigli medici.`
                }, language)}
              </p>
        
          </div>
    `
    
    const htmlBody = `
            <table width="100%" bgcolor="#fcba03" cellpadding="0" cellspacing="0" border="0">
                <tr>
                  <td align="center" style="padding: 40px 0;">
                    <table width="600" cellpadding="0" cellspacing="0" border="0"
                          style="background-color: #ffffff; border-radius: 10px; overflow: hidden; color: #343C5F; font-family: Arial, sans-serif;">
                      <tr>
                        <td style="padding: 30px;">
                          ${profilePictureLine}
                          <p style="margin: 0 0 15px 0;">${firstLine}</p>
                          <p style="margin: 0 0 15px 0;">
                            ${dT({
                              en:`I'm pleased to write to you to share something I believe may be helpful.`, 
                              it:`Mi fa piacere scriverle per condividere qualcosa che credo possa esserle utile.`}
                              , language)}
                          </p>
                          <p style="margin: 0 0 15px 0;">
                             ${dT({ 
                            en: `I'm excited to invite you to  ${reMind}, a gym for the mind, a space designed to help you continue the work we’ve been doing together 
                            between sessions. Through songs and affirmations carefully curated by me, ${reMind} offers a supportive, uplifting platform to 
                            strengthen your mindset throughout the week.`,
                            it: `Desiderlo invitarla a ${reMind}, una palestra per la mente: uno spazio pensato per aiutarla a proseguire il lavoro che stiamo svolgendo insieme tra una sessione e l’altra.
                            Attraverso canzoni e affermazioni da me accuratamente selezionate, ${reMind} offre una piattaforma di supporto e ispirazione per rafforzare la sua forza mentale durante la settimana.`
                            }, language)}
                          </p>
                          <p style="margin: 0 0 15px 0;">
                            ${dT({
                              en: `At the moment, ${reMind} is available by <b>invitation only, and I’ve reserved a place for you</b>. 
                              To join, simply click the link below`,
                              it: `Al momento, ${reMind} è disponibile <b>solo su invito, e ho riservato un posto per lei</b>.
                              Per accedere, le basterà cliccare sul link qui sotto”</b>.`
                            }, language)}
                          </p>

                          <p style="margin: 0 0 15px 0; text-align: center;">
                            <a href="https://reMind.is/login/?invited=true"
                              style="
                                display: inline-block;
                                background-color: #fcba03;
                                color: white;
                                text-decoration: none;
                                padding: 12px 24px;
                                border-radius: 10px;
                                margin-top: 15px;
                                margin-bottom: 15px;
                                font-weight: bold;
                                cursor: pointer;
                                font-family: sans-serif;
                              ">
                              ${dT({
                              en:`Click here to join reMind`, 
                              it:`Clicca qui per accedere a reMind`}, language)}
                            </a>
                          </p>
                          <p style="margin: 0 0 15px 0;>
                            ${dT({
                              en: `I believe it will be a powerful complement to our sessions, and I look forward to seeing you there.`,
                              it: `Credo che sarà un valido complemento al lavoro che stiamo facendo insieme, e non vedo l’ora di ritrovarla lì.`
                            }, language)}
                          </p>
                          <p style="margin: 0 0 15px 0;">
                            ${dT({
                              en: `Warm wishes,`,
                              it: `Un caro saluto,`
                            }, language)}
                          </p>
                          <h1 style="margin: 30px 0 0 0; font-size: 24px;">${userFullName}</h1>
                          <h4> ${userProfessionalTitle} </h4>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td align="center" style="padding:0 0 30px 0; width:600px">
                    ${footer}
                  </td>
                </tr>
              </table>
          `
    const emailDoc = () =>{ 
        const _id = generateMongoDBId()

        const doc = {
            _id,
            subject: dT({en: "Exclusive Invitation to reMind", it: "Invito esclusivo a reMind"}, language), //"Exclusive Invitation to reMind",
            htmlBody: htmlVersion(htmlBody, _id),
            richEditorObj: {},
            text: "",
            toEmail: email,
            sender: `${userFullName} ${dT({en: "is inviting you to reMind", it: "ti invita a reMind"}, language)}`,
            replyTo: user?.email, //replyTo
        }
        return doc
    }
      const postingEmailExpress = async(data, result=()=>{}) => {
    
        process.env.NODE_ENV === "development" && console.log("SENDING EMAIL", JSON.stringify(data))
       
        const response = await fetch(`${apiUrl}/email/send-email`,{
          method:"POST",
          headers: new Headers({'content-type': 'application/json'}), 
          body: JSON.stringify(data),

        })
        const dataResponse = await response.json()
        process.env.NODE_ENV === "development" && console.log("emailDataResponse",dataResponse)
        result(dataResponse)
        
      }

      const handleSubmit = async (e) => {
        e.preventDefault()
        //process.env.NODE_ENV === "development" && console.log("2 ids", generateMongoDBId(), generateMongoDBId())
        process.env.NODE_ENV === "development" && console.log("email", emailDoc())
        if (!email) {
          setEmailError(dT({en: "Please enter an email", it: "Per favore inserisci un indirizzo email"}, language))
          return
        }
        setEmailError(undefined)
        //process.env.NODE_ENV === "development" && console.log("signup", {email, password, companyId: companyId?.value, mindProId: mindProId?.value, userType: userType?.value})
        await signup({email, mindProId: user?._id, userType:"user", login: false, allowNoPassword: true, language: user?.language})
        ?.then(async()=>{
          await postingEmailExpress(emailDoc())})
        ?.then(()=>{
          successAlert(dT({en: 'Invite sent successfully!', it: 'Invito inviato con successo!'}, language),)
          setEmail("")
          setFirstName("")
        })
      }
      const testFunction = () => {
        process.env.NODE_ENV === "development" && console.log("testFunction",
          {
            user,
            userProfileData
          }
        )
        }

    if (!isGodMode(user) && !isMindPro(user)) {
        return <NoAccess />
    }

  if(userProfileDataLoading) return <Loading/>

  return (
    <div>
      <BlueButton fn={testFunction} hide={hideTestButtons} />  
      <form className="signup" onSubmit={handleSubmit}>
        <h3 style={{marginBottom: "10px"}}><T obj={{en:"Invite Client", it:"Invita Cliente"}}/></h3>
        <label>Email:</label>
        <input 
          type="email" 
          onChange={(e) => setEmail(e.target.value)} 
          value={email} 
        />
        <label><T obj={{en:"First Name", it:"Nome"}}/></label>
        <input 
          type="text" 
          onChange={(e) => setFirstName(e.target.value)} 
          value={firstName} 
        />
        
        <button disabled={isLoading}><T obj={{en:"Invite", it:"Invita"}}/></button>
        {emailError && <div className="error">{emailError}</div>}
      </form>
      <div style={{textAlign: "center", marginBottom: "30px"}}>
        <h2><T obj={{en:"Invite Preview", it:"Anteprima Invito"}}/></h2>
      </div>
      <div style={{  marginBottom: "120px"}} dangerouslySetInnerHTML={{ __html: htmlBody }} />
    </div>
  )
}

export default InviteClient
